import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function postProcessCampaign(data) {
  try {
    const response = await axios.post(`${REACT_APP_API}/leads/campaign/processCampaign`, data)
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}
